export const worklistCopyEn = {
    worklist: "Worklist",
    yourTasks: "Your tasks",
    description: "Complete clinician forms, consents, and missing event details across your patients.",
    emptyTitle: "You're all caught up",
    emptyDescription: "There are no outstanding clinician tasks right now.",
    noMatchingTasks: "No matching tasks",
    noMatchingTasksDescription: "Try changing your search, tab, or filters.",
    complete: "Complete",
    completeDetails: "Complete details",
    completeDetailsPanelDescription: "Fill in the missing details, then return to your worklist.",
    signConsent: "Sign consent",
    closePanel: "Close panel",
    noTaskSelected: "Select a task",
    noTaskSelectedDescription: "Choose a row to complete a form, consent, or missing event details here.",
    openDiary: "Open diary",
    openPatient: "Open patient",
    toDo: "To do",
    refresh: "Refresh",
    forms: "Forms",
    details: "Details",
    archived: "Archived",
    archive: "Archive",
    archiveAll: "Archive all",
    restoreAll: "Restore all",
    tasksSelected: (count: number) => (count === 1 ? "1 task selected" : `${count} tasks selected`),
    selectedTasksDescription: "Choose an action for the selected tasks.",
    selectTask: "Select task",
    selectAllTasks: "Select all tasks",
    restore: "Restore",
    archiveSucceeded: (count: number) => (count === 1 ? "Task archived." : `${count} tasks archived.`),
    archiveFailed: "Could not archive this task. Try again.",
    restoreSucceeded: (count: number) => (count === 1 ? "Task restored." : `${count} tasks restored.`),
    restoreFailed: "Could not restore this task. Try again.",
    emptyArchivedTitle: "Nothing archived",
    emptyArchivedDescription: "Tasks you archive stay here until you restore them.",
    allPeople: "All people",
    peopleFilterLabel: "People",
    selectPeople: "Select clinicians",
    organisationFilterLabel: "Organisation",
    allOrganisations: "All organisations",
    taskTypeFilterLabel: "Type of task",
    allTaskTypes: "All task types",
    searchTasks: "Search tasks",
    clearSearch: "Clear task search",
    filterTasks: "Filter tasks",
    filterTasksDescription: "Choose people, the organisation, and the type of task.",
    taskCompleteTitle: "Task recorded",
    taskCompleteDescription: "Continue to the next person on your worklist when you are ready.",
    taskCompleteAllDoneTitle: "All done",
    taskCompleteAllDoneDescription: "There are no more tasks in this list.",
    continueToNextTask: "Continue to next task",
    doNext: "Do next",
    doNextDescription: (task: string, patientName: string, hospitalNumber: string | null) =>
        hospitalNumber
            ? `${task} for ${patientName}. Hospital number: ${hospitalNumber}`
            : `${task} for ${patientName}`,
    nextPatientTask: (name: string) => `Next: ${name}`,
    returnToWorklist: "Return to worklist",
    patient: "Patient",
    hospitalNumber: "Hospital number",
    task: "Task",
    injectionDetailsTask: "Injection details",
    surgeryDetailsTask: "Surgery details",
    shockwaveDetailsTask: "Shockwave details",
    procedureDetailsTask: "Procedure details",
    consentTask: "Consent",
    due: "Due",
    status: "Status",
    actions: "Actions",
    dueLabel: "Due",
    blockedLabel: "Blocked",
    incompleteLabel: "Incomplete",
    blockedBy: (blocker: string) => `Complete ${blocker} first`,
    truncatedNotice: (total: number, shown: number) =>
        `Showing the first ${shown} of ${total} diaries with clinician forms. Narrow your patient list if you need the rest.`,
    unknownPatient: "Unknown patient",
    notDefined: "Not defined",
    loading: "Loading worklist…",
    errorLoading: (message: string) => `Could not load worklist: ${message}`,
    taskCount: (count: number) => (count === 1 ? "1 task" : `${count} tasks`),
};
